import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _to_property_key from "@swc/helpers/src/_to_property_key.mjs";
import { useState, useCallback } from 'react';
export function useReplyState() {
    const [replyingComments, setReplyingComments] = useState({});
    const onEditingStateChange = useCallback((commentId, state)=>(replyState)=>{
            const { [commentId]: value  } = replyState, rest = _object_without_properties(replyState, [
                commentId
            ].map(_to_property_key));
            if (state === 'replying') {
                setReplyingComments(_object_spread_props(_object_spread({}, rest), {
                    [commentId]: true
                }));
            } else {
                setReplyingComments(rest);
            }
        }, []);
    const isReplyingToComment = useCallback((parentId)=>!!replyingComments[parentId], [
        replyingComments
    ]);
    return {
        onEditingStateChange,
        isReplyingToComment
    };
}
